// ============================================
// JobTitleBadge Component
// Soft blue pill badge for job titles
// ============================================

import { cn } from '../../../utils/cn';

// ============================================
// Types
// ============================================

interface JobTitleBadgeProps {
  children: React.ReactNode;
  className?: string;
}

// ============================================
// Component
// ============================================

export function JobTitleBadge({ children, className }: JobTitleBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-3 py-2 text-xs font-semibold',
        'bg-[rgba(172,191,255,0.3)] text-[#394C84]',
        className
      )}
    >
      {children}
    </span>
  );
}
